// src/pages/QuickCapturePage.js

import { useState } from "react";
import { supabase } from "../supabaseClient";

export default function QuickCapturePage({ user }) {
  const [name, setName] = useState("");
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const handleCapture = async () => {
  if (!name.trim()) return;

  setSaving(true);

  const { error } = await supabase.from("inbox").insert([
    {
      name: name.trim(),
      notes: notes.trim() || null,
      user_id: user.id
    }
  ]);

  setSaving(false);

  if (error) {
    console.error("Quick Capture failed:", error);
    alert("Capture failed. Check console.");
    return;
  }

  setName("");
  setNotes("");
};
  return (
    <div className="page-shell">
      <h1>Quick Capture</h1>
      <p>Capture now. Clarify later.</p>

      <div className="quick-capture-card">
        <input
            type="text"
            placeholder="What needs your attention?"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                handleCapture()
                }
            }}
         />

        <textarea
          placeholder="Optional notes..."
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />

        <button onClick={handleCapture} disabled={saving}>
          {saving ? "Saving..." : "Capture"}
        </button>
      </div>
    </div>
  );
}